export default (
  state = {
    selectedCompanyMetrics: {},
    isFetchingSelectedCompanyMetrics: true,
    list: [],
  },
  action
) => {
  switch (action.type) {
    case "GET_COMPANIES_LIST_START":
      return { ...state, isFetchingCompaniesList: true };

    case "GET_COMPANIES_LIST_SUCCESS":
      return {
        ...state,
        isFetchingCompaniesList: false,
        list: action.data,
      };

    case "GET_COMPANIES_LIST_FAIL":
      return { ...state, isFetchingCompaniesList: false, list: [] };

    case "SEND_REMINDER_LOADING":
      return {
        ...state,
        isSendingReminder: true,
        isSendingReminderSuccess: false,
        isSendingReminderFail: false,
      };

    case "SEND_REMINDER":
      return {
        ...state,
        isSendingReminder: false,
        isSendingReminderSuccess: !action.error ? true : false,
        isSendingReminderFail: action.error ? true : false,
      };

    case "RESET_REMINDER_STATUS":
      return {
        ...state,
        isSendingReminder: false,
        isSendingReminderSuccess: false,
        isSendingReminderFail: false,
      };

    case "GET_COMPANY_METRICS_START":
      return {
        ...state,
        isFetchingSelectedCompanyMetrics: true,
        selectedCompanyMetrics: {},
      };

    case "GET_COMPANY_METRICS_FAIL":
      return {
        ...state,
        isFetchingSelectedCompanyMetrics: false,
        selectedCompanyMetrics: {},
      };

    case "GET_COMPANY_METRICS_SUCCESS":
      return {
        ...state,
        isFetchingSelectedCompanyMetrics: false,
        selectedCompanyMetrics: action.data,
      };
    default:
      return state;
  }
};
